/** TutorCloud iTEMA PDF branding and layout tokens (aligned with ppt/theme.js). */
export const pdfTheme = {
  primary: "#2563EB",
  text: "#101828",
  muted: "#64748B",
  border: "#E5E7EB",
  surface: "#F8FAFC",
  brandName: "TutorCloud iTEMA",
};

/** A4 print layout in millimetres. */
export const pdfLayout = {
  pageWidth: 210,
  pageHeight: 297,
  marginX: 14,
  headerHeight: 12,
  footerHeight: 10,
  marginBottom: 12,
  lineHeight: 5.5,
  sectionGap: 7,
  blockGap: 4,
  bulletIndent: 5,
  tableRowPadding: 2,
  tableCellPaddingX: 2,
  typography: {
    coverTitle: 22,
    coverSubtitle: 12,
    sectionTitle: 16,
    blockTitle: 13,
    body: 10.5,
    caption: 9,
    tableHeader: 10,
    tableCell: 9.5,
    headerLabel: 8,
    footerLabel: 8,
    worksheetTitle: 18,
    worksheetMeta: 10,
    questionNumber: 11,
    questionPrompt: 12,
    questionOption: 11,
    answerEntry: 10,
  },
  worksheet: {
    numberColumnWidth: 10,
    optionGap: 3.5,
    questionGap: 6,
    headerRuleGap: 4,
    nameLineGap: 8,
  },
};

export function getContentTop() {
  return pdfLayout.headerHeight + 6;
}

export function getContentBottom() {
  return pdfLayout.pageHeight - pdfLayout.footerHeight - pdfLayout.marginBottom;
}

export function getContentWidth() {
  return pdfLayout.pageWidth - pdfLayout.marginX * 2;
}
